import { render } from "./EmailInput.vue?vue&type=template&id=0785f5a6&lang=pug"
import script from "./EmailInput.vue?vue&type=script&lang=ts"
export * from "./EmailInput.vue?vue&type=script&lang=ts"
script.render = render

export default script